import Calendar from "./Calendar";

export default function CalendarWrapper() {
    return <Calendar />;
}
